

































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { doublePrevention, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class TaskAbnormalDialog extends Vue {
  private visible = false;
  imgPath: any = 'data:image/jpeg;base64,';
  picPath: any = '';
  formData: any = {};

  userRules: any = {};
  imagesList: any = [];
  listRowData: any = {};

  private async showAddDialog(data: any) {
    this.listRowData = data;
    this.imagesList = [];
    this.picPath = publishObjectPath.imgPathWater;
    this.getPatrolHazardCheckData(data.id);
    this.visible = true;
  }

  getPatrolHazardCheckData(id: any) {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getPatrolHazardCheckShellDetail(id)
      .then(async (res: any) => {
        this.formData = res.data;
        const resInner: any = await this.getSignatureData(res.data.staffSign);
        this.formData.staffSign = resInner.signature;
        this.getSysFile(res.data.images);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  getSysFile(id: any) {
    performanceServer.getSysFile(id).then((res: any) => {
      this.imagesList = res.data;
    });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }
}
